export default __webpack_public_path__ + "static/media/TriangleShadingT.be0b38d7.png";